import { IScheduleAttendanceRequest } from '../../interfaces/schedule-attendance.interface'
import {
  IApproveLocationScheduleRequest,
  IRejectLocationScheduleRequest,
  IScheduledEmployee,
  ISchedulerEventInfo
} from '../../interfaces/scheduler.interface'

export class SetSchedulerData {
  static readonly type = '[scheduler] Set Scheduler Data'
  constructor(
    public workDayDate: Date | string,
    public templateIndex: number,
    public employees: IScheduledEmployee[]
  ) {}
}

export class CopySchedulerData {
  static readonly type = '[scheduler] Copy Scheduler Data'
  constructor(public dayIndex: number) {}
}

export class GetLocationSchedule {
  static readonly type = '[scheduler] Get Location Schedule'
  constructor(
    public locationId: string,
    public weekNumber: string
  ) {}
}

export class RejectLocationSchedule {
  static readonly type = '[scheduler] Reject Location Schedule'
  constructor(public payload: IRejectLocationScheduleRequest) {}
}

export class ResetPreviousLocationSchedule {
  static readonly type = '[scheduler] Reset Previous Location Schedule'
}

export class CopyPreviousLocationSchedule {
  static readonly type = '[scheduler] Copy Previous Location Schedule'
}

export class GetPreviousLocationSchedule {
  static readonly type = '[scheduler] Get Previous Location Schedule'
  constructor(
    public locationId: string,
    public weekNumber: string
  ) {}
}

export class GetEmployeesBookedSchedule {
  static readonly type = '[scheduler] Get Employees Booked Schedule'
  constructor(public weekNumber: string) {}
}

export class SetLocationSchedule {
  static readonly type = '[scheduler] Set Location Schedule'
  constructor(
    public locationId: string,
    public weekNumber: string
  ) {}
}

export class ApproveLocationSchedule {
  static readonly type = '[scheduler] Approve Location Schedule'
  constructor(public payload: IApproveLocationScheduleRequest) {}
}

export class GetAllLocationSchedules {
  static readonly type = '[scheduler] Get All Location Schedules'
  constructor(public weekNumber: string) {}
}

export class DeleteLocationSchedule {
  static readonly type = '[scheduler] Delete Location Schedule'
  constructor(public locationScheduleId: string) {}
}

export class GetScheduleTemplate {
  static readonly type = '[scheduler] Get Schedule Template'
  constructor(public locationId: string) {}
}

export class SetScheduleTemplate {
  static readonly type = '[scheduler] Set Schedule Template'
  constructor(public locationId: string) {}
}

export class CopyScheduleTemplate {
  static readonly type = '[scheduler] Copy Schedule Template'
  constructor(public dayIndex: number) {}
}

export class SetScheduleTemplateData {
  static readonly type = '[scheduler] Set Schedule Template Data'
  constructor(
    public workDayDate: Date | string,
    public abbreviation: string,
    public defaultEvents: ISchedulerEventInfo[],
    public expectedEmployeeCount: number
  ) {}
}

export class SetScheduleTemplateOpenHours {
  static readonly type = '[scheduler] Set Schedule Template Open Hours'
  constructor(
    public workDayDate: Date | string,
    public openHours: ISchedulerEventInfo
  ) {}
}

export class CancelRegionalManagerApproval {
  static readonly type = '[scheduler] Cancel Regional Manager Approval'
  constructor(public locationScheduleId: string) {}
}

export class GetScheduleAttendance {
  static readonly type = '[scheduler] Get Schedule Attendance'
  constructor(public payload: IScheduleAttendanceRequest) {}
}
